import { asMultiStyleConfig } from '../../../../utils/theme';
export var Alert = asMultiStyleConfig({
  parts: ['container', 'title', 'description', 'icon', 'actionContainer'],
  baseStyle: {
    container: {
      borderRadius: 'unset'
    },
    actionContainer: {
      ml: {
        base: 0,
        md: 16
      }
    }
  },
  colorSchemes: {
    blue: {
      container: {
        backgroundColor: 'blue.50',
        borderColor: 'blue.275'
      },
      icon: {
        color: 'blue.275'
      }
    },
    red: {
      container: {
        backgroundColor: 'red.50',
        borderColor: 'red.850'
      },
      icon: {
        color: 'red.850'
      }
    },
    green: {
      container: {
        backgroundColor: 'green.900',
        borderColor: 'green.500'
      },
      icon: {
        color: 'green.500'
      }
    },
    yellow: {
      container: {
        backgroundColor: 'yellow.900',
        borderColor: 'orange.550'
      },
      icon: {
        color: 'orange.550'
      }
    }
  },
  sizes: {
    md: {
      container: {
        borderRadius: 'xs'
      }
    }
  },
  variants: {
    inline: {
      container: {
        border: '2px solid',
        borderRadius: 'xs'
      }
    },
    subtle: {
      icon: {
        w: {
          base: 5,
          md: 6
        },
        h: {
          base: 5,
          md: 6
        }
      }
    }
  }
});